import { ProductAddonTypeTyKeys } from '@teinor/erp/types/company/config/parameter'
import { useCallback, useEffect, useState } from 'react'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import LoadingSpinner from '../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import BaseScreenTableInner from '../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getConfigParam } from '../../../../../utils/reducers/getters'
import { ModalCEProductAddonBuy, ModalCEProductAddonSell } from './ModalCEProductAddon'
import { ModalDeleteProductAddonBuy, ModalDeleteProductAddonSell } from './ModalDeleteProductAddon'
import { RightHeaderProductAddonSelectorBuy, RightHeaderProductAddonSelectorSell, RightHeaderTitleProductAddonBuy, RightHeaderTitleProductAddonSell, RightHeaderTitleProductAddonUnify } from './RightHeaderProductAddon'
import { TableProductAddonsBuy, TableProductAddonsSell } from './TableProductAddons'
import { ProductAddonComponentTy, ProductAddonTypesInversedKeys } from './type'
import './productAddon.sass'

interface ProductAddonCompleteProps extends ComponentWithPermissions {
    basicData: any | null
    getData: () => Promise<void>
}

const ProductAddonComplete: React.FC<ProductAddonCompleteProps> = ({ basicData, userPermissions, getData }) => {
    const {t} = useTwinTranslation()
    const { typeProductAddon, setTypeProductAddon, myProductAddonType } = useProductAddonCompleteLogic({ basicData })
    const hasJustCategoryComplements = !basicData.hasComplements && basicData.hasCategoryComplements
    const hasJustCategoryComplementsBuy = !basicData.hasComplementsBuy && basicData.hasCategoryComplementsBuy
    basicData['getData'] = getData
    basicData['typeProductAddon'] = typeProductAddon
    basicData['setTypeProductAddon'] = setTypeProductAddon
    const dictProductAddonTy: ProductAddonComponentTy = {
        0: {
            TableComponent: TableProductAddonsSell as any,
            RightHeader: RightHeaderProductAddonSelectorSell,
            ModalCreate: ModalCEProductAddonSell,
            ModalDelete: ModalDeleteProductAddonSell,
            extraWhereParams: {
                'ProductAddonRel.ProductId': basicData?.id,
                CategoryMainId: basicData.CategoryMainId,
                hasJustCategoryComplements,
                getData
            }
        },
        1: {
            TableComponent: TableProductAddonsBuy as any,
            RightHeader: RightHeaderProductAddonSelectorBuy,
            ModalCreate: ModalCEProductAddonBuy,
            ModalDelete: ModalDeleteProductAddonBuy,
            extraWhereParams: {
                'ProductAddonBuyRel.ProductId': basicData?.id,
                CategoryMainId: basicData.CategoryMainId,
                hasJustCategoryComplements: hasJustCategoryComplementsBuy,
                getData
            }
        },
    }
    const pageData = {
        title: '',
        newText: t('add', 'Añadir'),
    }

    const productType = dictProductAddonTy[typeProductAddon]
    const dictHeaderProductAddons: Record<ProductAddonTypeTyKeys, React.FC<ModalEditComponentProps>> = {
        0: typeProductAddon === 0 ? RightHeaderProductAddonSelectorSell : RightHeaderProductAddonSelectorBuy ,
        1: RightHeaderTitleProductAddonSell, 
        2: RightHeaderTitleProductAddonBuy,
        3: RightHeaderTitleProductAddonUnify,
    }
    if (myProductAddonType === null){
        return <LoadingSpinner />
    }
    return (
        <BaseScreenTableInner className='single_product_addons' TableComponent={productType.TableComponent} pageData={pageData} userPermissions={userPermissions} basicData={basicData} RightHeader={dictHeaderProductAddons?.[myProductAddonType|| 0]} CreateModalComponent={productType.ModalCreate} DeleteModalComponent={productType.ModalDelete} extraWhereParams={productType.extraWhereParams} />
    )
}

interface ProductAddonCompleteLogicProps {
    basicData: any | null 
}

const useProductAddonCompleteLogic = ({ basicData }: ProductAddonCompleteLogicProps) => {
    const [typeProductAddon, setTypeProductAddon] = useState<ProductAddonTypesInversedKeys>(0)
    const [myProductAddonType, setMyProductAddonType] = useState < ProductAddonTypeTyKeys | null>(null)

    const getMyProductAddonType = useCallback(async () => {
        let productAddonType: any = basicData?.productAddonType ?? null
        if (productAddonType === null){
            const result = await twinFetchPostJSON('/api/app/product/category/getCategoryInstance', { id: basicData.CategoryMainId })
            if (result) {
                productAddonType = result.productAddonType ?? null
            }
            if (productAddonType === null){
                productAddonType = getConfigParam('productAddonType') || 3
            }
        }
        setMyProductAddonType(productAddonType)
        if(productAddonType === 2){
            setTypeProductAddon(1)
        }
    }, [basicData?.productAddonType, basicData.CategoryMainId])

    useEffect(() => {
        getMyProductAddonType()
    }, [getMyProductAddonType])

    return { typeProductAddon, setTypeProductAddon, myProductAddonType }
}

export default ProductAddonComplete